import { render } from "./MobileKaiJgg.vue?vue&type=template&id=b0e80ed0&scoped=true"
import script from "./MobileKaiJgg.vue?vue&type=script&lang=js"
export * from "./MobileKaiJgg.vue?vue&type=script&lang=js"

import "./MobileKaiJgg.vue?vue&type=style&index=0&id=b0e80ed0&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e80ed0"]])

export default __exports__